import type * as Cesium from 'cesium';

// Workaround for a Cesium bug (1.119; re-check on upgrade): its terrain index cache keeps every WebGL
// context it drew with, so a destroyed viewer's context and GPU memory would live for the whole tab.
export const destroyCesiumViewer = (viewer: Cesium.Viewer) => {
  const { canvas } = viewer;
  viewer.destroy();
  (canvas.getContext('webgl2') ?? canvas.getContext('webgl'))?.getExtension('WEBGL_lose_context')?.loseContext();
};
